// Function to handle request errors and return appropriate messages
export const requestErrors = (error) => {
  if (typeof error.response?.data == "string") {
    return error.response?.data;
  } else if (error.response && error.response.status === 401) {
    return "انتهت صلاحية الجلسة الخاصة بك.الرجاد الدخول على الحساب من جديد.";
  } else if (error?.code === "ERR_NETWORK") {
    return "تاكد من الاتصال بالانترنت واعادة المحاولة";
  } else {
    return "فشل في العملية";
  }
};

// Function to check SMS balance status
export const smsBalanceStatus = (amount) => {
  if (typeof amount === "number") {
    return amount <= 1000;
  } else {
    return amount != null || amount === undefined;
  }
};
